import EditTransferParamModal from './EditTransferParamModal.js'
import TransferListFilterModal from './TransferListFilterModal/index.js'

export default function Modals() {
  return (
    <>
      <EditTransferParamModal />
      <TransferListFilterModal />
    </>
  )
}
